// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__6j1zw","header":"App_header__14Wxn","clinics":"App_clinics__Gmko3","city":"App_city__2KadP"};